import React from 'react';
import InfoModalItem from './InfoModalItem';

import { volar, latam, portones, on } from '../data';

const InfoModal = ({ group, card }) => {
  let g;
  let c;

  switch (group) {
    case 1:
      g = volar;
      break;
    case 2:
      g = latam;
      break;
    case 3:
      g = on;
      break;
    case 4:
      g = portones;
      break;

    default:
      break;
  }

  switch (card) {
    case 1:
      c = 'regional';
      break;
    case 2:
      c = 'internacional';
      break;
    case 3:
      c = 'oro';
      break;
    case 4:
      c = 'platinum';
      break;
    case 5:
      c = 'infinite';
      break;

    default:
      break;
  }

  let cardType = g[c];

  function createMarkup(html) {
    return { __html: html };
  }

  return (
    <div className="info-modal">
      {cardType.map((item, i) => (
        <InfoModalItem key={i} title={item.title} icon={item.icon}>
          {item.content.map((p, i) => (
            <p key={`p-${i}`} dangerouslySetInnerHTML={createMarkup(p)} />
          ))}
        </InfoModalItem>
      ))}
    </div>
  );
};

export default InfoModal;
